/**
 * Inngest-события модуля `support`.
 *
 * Оба события несут только идентификаторы: тело обращения и ответ оператора
 * остаются в БД. Причина та же, по которой мы не храним сырые payload'ы
 * (rules/compliance.md §7) — свободный текст человека это неизвестно что,
 * и таскать его копию по очередям и логам мы не будем.
 *
 * SET-событий здесь нет: обращение в поддержку не меняет ни профиль, ни
 * права, ни баланс, и сервисам экосистемы знать о нём нечего.
 */
import { z } from "zod";
import { IsoDateTimeSchema, UuidV7Schema } from "../_shared/primitives.js";

/** Обращение отправлено: письмо внутрь + подтверждение человеку. */
export const SupportRequestSubmittedEventSchema = z.object({
	name: z.literal("support/request.submitted"),
	data: z.object({
		ticketId: UuidV7Schema,
		submittedAt: IsoDateTimeSchema,
	}),
});

/** Оператор ответил: письмо человеку в нашем шаблоне. */
export const SupportReplySentEventSchema = z.object({
	name: z.literal("support/reply.sent"),
	data: z.object({
		ticketId: UuidV7Schema,
		messageId: UuidV7Schema,
		repliedAt: IsoDateTimeSchema,
	}),
});

/**
 * Подметание недоставленных писем поддержки. Данных нет — это ручной или
 * cron-запуск; событие заведено, потому что «положили в БД и не смогли
 * отправить» обязано иметь свипер, а не только лог (инвариант №14).
 */
export const SupportDeliverySweepEventSchema = z.object({
	name: z.literal("support/delivery.sweep"),
	data: z.object({}),
});
